// Descarga de archivos que entrega el servidor (copias controladas, informes exportados).

const DISPOSITION_NAME = /;\s*filename="?([^";]*)"?/i;
/** Tiempo para que el navegador lea el archivo antes de liberar la URL. */
export const REVOKE_MS = 60_000;

/** Nombre del archivo en Content-Disposition. Solo se acepta un nombre plano con la
 *  extensión esperada (sin rutas ni `..`); cualquier otro devuelve null. */
export function dispositionFileName(header: string | null, ext: 'pdf' | 'csv'): string | null {
  const name = header === null ? undefined : DISPOSITION_NAME.exec(header)?.[1];
  const safe = new RegExp(`^[A-Za-z0-9_-][A-Za-z0-9._-]*[.]${ext}$`);
  return name !== undefined && safe.test(name) && !name.includes('..') ? name : null;
}

/** Guarda una URL (blob:) como archivo con ese nombre. */
export function saveUrl(url: string, name: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.append(a);
  a.click();
  a.remove();
}

/** Guarda un blob como archivo y libera su URL cuando el navegador ya lo leyó. */
export function saveBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  saveUrl(url, name);
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_MS);
}
